/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * プレスリリース種類
 * @export
 * @interface PressReleaseType
 */
export interface PressReleaseType {
    /**
     * プレスリリース 種類id
     * @type {string}
     * @memberof PressReleaseType
     */
    releaseTypeId: string;
    /**
     * プレスリリース 種類名
     * @type {string}
     * @memberof PressReleaseType
     */
    releaseTypeName: string;
}

export function PressReleaseTypeFromJSON(json: any): PressReleaseType {
    return PressReleaseTypeFromJSONTyped(json, false);
}

export function PressReleaseTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressReleaseType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'releaseTypeId': json['release_type_id'],
        'releaseTypeName': json['release_type_name'],
    };
}

export function PressReleaseTypeToJSON(value?: PressReleaseType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'release_type_id': value.releaseTypeId,
        'release_type_name': value.releaseTypeName,
    };
}

